export enum MenuTypes {
  MENU_SETUP = '@menu/MENU_SETUP',
}
